module.exports = __webpack_public_path__ + "media/images/ic-pin-blue-fullfiled-0ab3ee0c98167b6db0593897264413dd.svg";